import ApiError from "./ApiError";

export default class LessonPermissionsError extends ApiError{
}
